<div style="padding:10% 10px 0 10px; text-align: center;">

    <div>
        <img [src]="'/apps/'+app+'/splash.png'" width="180" align="center">
    </div>
    <div style="display:flex; flex-direction:column; align-items: center; ">
        The verification link is no longer valid.

        <div style="margin-top: 2em;" class="text_link">
            <a [href]="'/?app='+app" style="color:#1CA0DA;">
                <span>Go to Login</span>
            </a>
        </div>


    </div>


</div>